"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.record.id': 'Record ID',
    'onboarding.record.progress': 'Progress',
    'onboarding.record.created': 'Created',
    'onboarding.record.updated': 'Last Updated',
    'onboarding.record.view': 'View Details',
    'onboarding.record.continue': 'Continue',
};
